import { render, staticRenderFns } from "./TabbedDashboard.vue?vue&type=template&id=1db7e1cd&scoped=true"
import script from "./TabbedDashboard.vue?vue&type=script&lang=js"
export * from "./TabbedDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7e1cd",
  null
  
)

export default component.exports